<script>
    import R, {LOADER} from "../../lib/requests";
    import user from "../../stores/user";
    import {setFocusTo} from "../../lib/lib";
    import Notifier from "../../stores/notifier";
    import PageHeader from "../../components/PageHeader.svelte";
    import PasswordControl from "../../components/controls/PasswordControl.svelte";
    import InputGroupColor from "../../components/controls/InputGroupColor.svelte";

    let account = null;
    let showPassword = false;

    const load = () => {

        const onSuccess = result => {
            account = result;
            setFocusTo('accountName');
        }

        const onFailure = err => {
        };

        R.handle(R.account.details, [], onSuccess, onFailure, LOADER.PAGE);
    };

    const save = () => {
        const onSuccess = result => {
            account = result;
            $user.name = result.name;
            $user.color = result.color;
            onCancelPassword();
            Notifier.showMessage("Ο λογαριασμός σας ενημερώθηκε");
        }

        const onFailure = err => {
        };

        R.handle(R.account.edit, account, onSuccess, onFailure, LOADER.POPUP);
    }

    const onChangePassword = () => {
        showPassword = true;
        setFocusTo('newPassword');
    }

    const onCancelPassword = () => {
        showPassword = false;
        delete (account.new_password);
    }

    load();
</script>

<PageHeader title="Ο Λογαριασμός μου"/>
{#if account}
    <div class="row">
        <div class="col-lg-4">
            <div class="panel-simple panel-pad">
                <h4 class="mb-4">
                    { account.email }
                </h4>
                <div class="form-group">
                    <label>Όνομα</label>
                    <div class="input-group">
                        <input type="text" class="form-control" id="accountName" bind:value="{ account.name }"
                               required>
                        <InputGroupColor bind:value="{ account.color }"/>
                    </div>
                </div>
                <!--                <div class="form-group">-->
                <!--                    <label>E-mail</label>-->
                <!--                    <input type="email" class="form-control" bind:value="{ account.email }" readonly>-->
                <!--                </div>-->
                {#if !showPassword}
                    <button class="btn btn-link px-0" on:click={ onChangePassword }>αλλαγή κωδικού</button>
                {:else}
                    <div class="form-group">
                        <label>Νέος κωδικός</label>
                        <PasswordControl id="newPassword" bind:value="{ account.new_password }"/>
                        <button class="btn btn-link px-0" on:click={ onCancelPassword }>να μην αλλάξει ο κωδικός μου
                        </button>
                    </div>
                {/if}
                <hr>
                <div class="text-end">
                    <button class="btn btn-primary" on:click={ save }>ΕΝΗΜΕΡΩΣΗ</button>
                </div>
            </div>
        </div>
    </div>
{/if}